import { customizableTitles, customizableText } from '../../constants/activation-brief-default-copy';
import get from 'lodash-es/get';
import { ACTIVATION_BRIEF_CUSTOMIZED_STEP_TITLE_KEYS } from '../../constants/activation-brief-step-titles';

export function getActivationCustomizableTitle(activation, key) {
    const title = get(activation, `customization.${key}`, null);

    return title !== null ? title : customizableTitles[key];
}

export function getActivationCustomizableText(activation, key, defaultText) {
    let text = get(activation, `customization.${key}`, null);

    if (text === null && defaultText) {
        text = defaultText;
    }

    return text !== null ? text : customizableText[key];
}

export function getActivationStepTitle(activation, stepAlias) {
    return getActivationCustomizableTitle(activation, get(ACTIVATION_BRIEF_CUSTOMIZED_STEP_TITLE_KEYS, stepAlias));
}

/**
 * @param brief {object}
 * @param key {string}
 * @return {string}
 */
export function getCustomizableTitle(brief, key) {
    return getActivationCustomizableTitle(get(brief, 'activation'), key);
}

export function getCustomizableText(brief, key, defaultText) {
    return getActivationCustomizableText(get(brief, 'activation'), key, defaultText);
}

export function getStepTitle(brief, stepAlias) {
    return getActivationStepTitle(get(brief, 'activation'), stepAlias);
}
